import React from "react";
import { PPTStatTiles } from "../PPTStatTiles";
import { PROMO_STAT_TILES } from "ppt/constants";
import { usePPTActions, usePPTState } from "tap/store/ppt/usePPT";

/**
 * Promotion-list binding for PPTStatTiles: selects its own counts and filter
 * state from Redux, so the home page just drops it in. PPTPromosGrid reads the
 * same `promosIssueFilter` to filter its rows.
 */
export const PPTPromosStatTiles = () => {
  const { promosTileCounts, promosIssueFilter } = usePPTState();
  const { setPromosIssueFilter } = usePPTActions();

  return (
    <PPTStatTiles
      counts={promosTileCounts}
      selectedFilter={promosIssueFilter}
      onSelect={setPromosIssueFilter}
      visibleTiles={PROMO_STAT_TILES}
      noun="promotions"
    />
  );
};
